
import { Component, Vue } from 'vue-property-decorator';
import OnlineNumber from './online-number.vue';
import NodeStatue from './node-status.vue';
import DeviceStatus from './device-status.vue';
@Component({
  components: { OnlineNumber, NodeStatue, DeviceStatus },
})
export default class extends Vue {}
